<div class="modal-header">
    <h4 class="modal-title pull-left">{{ titulo }}</h4>
    <span title="Fechar" aria-hidden="true" class="pull-right material-icons icon-24 cursor" (click)="bsModalRef.hide()">close</span>
</div>
<div class="modal-body">
    <ng-content></ng-content>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Fechar</button>
</div>